import React, { useState } from 'react';
import { Select, SelectItem } from 'carbon-components-react';

const CustomSelect = props => {
  const [value, setValue] = useState(props.formData);
  let label = props.schema.title;

  if (props.required) label += ' *';

  const onChange = event => {
    const selected = event.currentTarget.selectedIndex;
    const enumValues = props.schema.enum;
    setValue(enumValues[selected]);
    props.onChange(enumValues[selected]);
  };

  return (
    <Select
      id={props.idSchema.$id}
      className='form-item_select'
      defaultValue={value}
      light
      invalidText='A valid value is required'
      labelText={label}
      onChange={onChange}
      disabled={props.schema.readOnly}
      style={{
        background: 'white',
        width: '478px'
      }}
    >
      {props.schema.enum.map((option, i) => (
        <SelectItem
          key={`${props.idSchema.$id}-option-${i}`}
          value={option}
          text={props.schema.enumNames[i]}
        />
      ))}
    </Select>
  );
};

export default CustomSelect;
